import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  new: { label: "New", cls: "bg-slate-50 text-slate-700 border-slate-200" },
  in_review: { label: "In review", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  disputed: { label: "Disputed", cls: "bg-rose-50 text-rose-800 border-rose-200" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  published: { label: "Published", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  revoked: { label: "Revoked", cls: "bg-zinc-100 text-zinc-700 border-zinc-300" },
  active: { label: "Active", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  pending_review: { label: "Pending review", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  freezing: { label: "Freezing", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  connected: { label: "Connected", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  disconnected: { label: "Disconnected", cls: "bg-slate-50 text-slate-600 border-slate-200" },
  healthy: { label: "Healthy", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  partial: { label: "Partial", cls: "bg-amber-50 text-amber-800 border-amber-200" },
};

const DOT_BY_VALUE = {
  approved: "bg-emerald-600",
  active: "bg-emerald-600",
  completed: "bg-emerald-600",
  connected: "bg-emerald-600",
  healthy: "bg-emerald-600",
  in_review: "bg-amber-600",
  pending_review: "bg-amber-600",
  freezing: "bg-amber-600",
  partial: "bg-amber-600",
  disputed: "bg-rose-600",
  published: "bg-sky-600",
  revoked: "bg-zinc-500",
};

const dotFor = (v) => DOT_BY_VALUE[v] || "bg-slate-400";

export const StatusBadge = ({ value, className }) => {
  const m = MAP[value] || { label: value, cls: "bg-slate-50 text-slate-700 border-slate-200" };
  return (
    <span
      data-testid={`status-badge-${value}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-[11px] font-mono uppercase tracking-wider",
        m.cls,
        className,
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", dotFor(value))} />
      {m.label}
    </span>
  );
};

export default StatusBadge;
